<div class="products">
  <div class="card-skeleton" *ngFor="let item of items">
    <div class="image-placeholder"></div>
    <div class="content-placeholder">
      <div class="title-placeholder"></div>
      <div class="desc-placeholder"></div>
    </div>
  </div>
</div>